<template>
  <div ref="monitoringContent" class="broadcast-system container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--卡片数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="终端列表" name="0" class="node-list-page">
            <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleFormQuery()">
              <el-form-item>
                <el-button @click="handleFormQuery()" type="primary">刷 新</el-button>
              </el-form-item>
              <el-form-item style="float:right">
                <span>总数</span><el-badge class="mark" :value="pageTotalCount" type="primary"/>
                <span>正常</span><el-badge class="mark" :value="pageNormalCount" type="success"/>
                <span>离线</span><el-badge class="mark" :value="pageErrorCount" type="info"/>
              </el-form-item>
            </el-form>
            <div class="general-container">
              <div ref="cardContianer" class="card-container">
                <!--最大为3行-->
                <el-row style="margin-bottom: 10px" v-for="(rowItem, rowIndex) in cardMaxRowCount" :key="rowItem">
                  <!--每行最大为6列-->
                  <el-col :span="24/cardMaxColCount" v-for="(colItem, colIndex) in cardMaxColCount" :key="colItem" :offset="0">
                    <el-card class="node-card" v-show="rowIndex*cardMaxColCount + colIndex < cardData.length">
                      <div slot="header" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null">
                        <el-checkbox v-model="cardSelectedStates[rowIndex*cardMaxColCount + colIndex]" v-show="voiceOpenMode !== 1"></el-checkbox>
                        <span class="card-header-title" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardCurrentItem === cardData[rowIndex*cardMaxColCount + colIndex] ? 'active':''">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].name : ''}}
                        </span>
                        <span style="float: right;height: 30px;line-height: 30px;font-size: 16px" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].letPass === 2 ? 'alarm-color':'normal-color'">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? getNameById(cardData[rowIndex*cardMaxColCount + colIndex].letPass, $type.diLetPasss):''}}
                        </span>
                      </div>
                      <div class="card-body-content" @click="cardCurrentItem = cardData[rowIndex*cardMaxColCount + colIndex];">
                        <div class="status-text-container">
                          <el-image class="status-icon" :src="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].pictureUrl:''"></el-image>
                          <span class="status-text"
                                :class="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].state === 0 ? 'off-color':'on-color' :''">
                          {{ cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].state === 0 ? '空闲中':'通话中' : ''}}
                          </span>
                        </div>
                        <div class="button-container">
                          <el-button type="primary"
                                     @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleCall();">
                            呼叫
                          </el-button>
                          <el-button type="primary"
                                     @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleAnswer();">
                            接听
                          </el-button>
                          <el-button type="danger"
                                     @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleHang();">
                            挂断
                          </el-button>
                        </div>
                      </div>
<!--                      <div class="card-body-footer">-->
<!--                      </div>-->
                    </el-card>
                  </el-col>
                </el-row>
              </div>
              <el-pagination
                background
                @current-change="handleCurrentPageChange"
                :current-page.sync="cardQueryParams.pageNum"
                :page-size.sync="cardQueryParams.pageSize"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next, jumper"
                :total="cardTotalItem">
              </el-pagination>
              <el-tabs class="node-control-bar" v-model="activeControlBarTabName" @tab-click="handleControlBarTabClick">
                <el-tab-pane label="双向对讲" name="0" class="button-container">
                  <el-button type="primary" @click=handleCall();>呼叫</el-button>
                  <el-button type="primary" @click=handleAnswer();>接听</el-button>
                  <el-button @click=handleHang();>挂断</el-button>
                </el-tab-pane>
                <el-tab-pane label="采集广播" name="1" class="button-container">
                  <el-checkbox v-model="allCardSelected" @change="handleAllCardSelectedChange">全选</el-checkbox>
                  <br><br>
                  <el-button type="primary" @click=handleStartBroadcast();>开始广播</el-button>
                  <el-button type="plain" @click=handleStopBroadcast();>停止广播</el-button>
                </el-tab-pane>
                <el-tab-pane label="文件广播" name="2" class="button-container">
                  <el-checkbox v-model="allCardSelected" @change="handleAllCardSelectedChange">全选</el-checkbox>
                  <br><br>
                  <span>播放模式：</span>
                  <el-radio-group v-model="controlParams.fromfilePlayMode" style="margin-right: 20px">
                    <el-radio :label="0">单次播放</el-radio>
                    <el-radio :label="1">循环播放</el-radio>
                  </el-radio-group>
                  <span style="margin-right: 20px">选中文件数：{{controlParams.fromFileIndexList.length}}</span>
                  <el-button type="primary" @click=handleSelectFile();>选择文件</el-button>
                  <el-button type="primary" @click=handleStartFilePlay();>开始广播</el-button>
                  <el-button type="plain" @click=handleStopFilePlay();>停止广播</el-button>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--选择文件弹窗-->
    <select-file-modal v-if="selectedFileModalOpen" :modalOpen="selectedFileModalOpen" :selectedFileIndexs="controlParams.fromFileIndexList" @submit="handleSelectFileModalSubmit" @cancel="handleSelectFileModalCancel"></select-file-modal>

  </div>
</template>

<script type="text/ecmascript-6">
import BroadcastSystem from './BroadcastSystem.js'

export default BroadcastSystem
</script>

<style lang="scss">
  @import "BroadcastSystem.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/BroadcastSystem/BroadcastSystem.vue